<template>
  <!-- 崇信县中医医院 -->
  <div class="pageContent">
    <!-- <img src="../../../assets/wuxue.png" alt="Login logo" class="loginLogo" /> -->
    <!-- 姓名，身份证号 -->
    <div class="title">输入姓名/身份证号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="value25500004.name25500004"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model="value25500004.value1"
          placeholder="请输入身份证绑定信息"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      rules: true,
      value25500004: {
        name25500004: "",
        value1: "",
      },
      IDcard: ""
    };
  },
  methods: {
    inputFn() {
      if (this.value25500004.name25500004 != "" && this.value25500004.value1 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("value25500004", JSON.stringify(this.value25500004));
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name25500004")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.title {
  padding: 65px 0 20px;
  font-size: 19px;
  font-weight: 800;
}
.pageContent {
  .hosName {
    font-size: 20px;
    // padding: 10px 0;
    padding: 65px 0 10px;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
